import { render, staticRenderFns } from "./addmessageone.vue?vue&type=template&id=74a4141b&scoped=true"
import script from "./addmessageone.vue?vue&type=script&lang=js"
export * from "./addmessageone.vue?vue&type=script&lang=js"
import style0 from "./addmessageone.vue?vue&type=style&index=0&id=74a4141b&prod&scoped=true&lang=css"
import style1 from "./addmessageone.vue?vue&type=style&index=1&id=74a4141b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4141b",
  null
  
)

export default component.exports